import { useEffect, useRef } from "react";
import "@/index.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { ConsultationProvider } from "@/components/Consultation";
import { ThemeProvider } from "@/components/Theme";
import { Header, Footer } from "@/components/Chrome";
import HomePage from "@/pages/HomePage";
import ShopPage from "@/pages/ShopPage";
import ProductPage from "@/pages/ProductPage";
import CollectionsPage from "@/pages/CollectionsPage";
import BespokePage from "@/pages/BespokePage";
import DesignerPage from "@/pages/DesignerPage";
import JournalPage from "@/pages/JournalPage";
import MeasurePage from "@/pages/MeasurePage";
import AtelierPage from "@/pages/AtelierPage";

let lenisRef = null;

const SmoothScroll = () => {
  const location = useLocation();
  useEffect(() => {
    const lenis = new Lenis({ autoRaf: true, lerp: 0.09 });
    lenisRef = lenis;
    return () => lenis.destroy();
  }, []);
  useEffect(() => {
    lenisRef?.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, [location.pathname]);
  return null;
};

function App() {
  return (
    <div className="grain min-h-screen bg-ink text-bone">
      <BrowserRouter>
        <ThemeProvider>
        <ConsultationProvider>
          <SmoothScroll />
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/shop" element={<ShopPage />} />
              <Route path="/product/:id" element={<ProductPage />} />
              <Route path="/collections" element={<CollectionsPage />} />
              <Route path="/bespoke" element={<BespokePage />} />
              <Route path="/designer" element={<DesignerPage />} />
              <Route path="/journal" element={<JournalPage />} />
              <Route path="/measure" element={<MeasurePage />} />
              <Route path="/atelier" element={<AtelierPage />} />
              <Route path="*" element={<HomePage />} />
            </Routes>
          </main>
          <Footer />
          <Toaster theme="dark" position="bottom-right" />
        </ConsultationProvider>
        </ThemeProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
